import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import db from "../db";
import CategoryLists from "../components/CategoryLists";
import "../assets/styles/main.css";
import ErrorSuccessMessage from "../components/ErrorSuccessMessage";

function AddCategory() {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [selectedParent, setSelectedParent] = useState(null);
  // const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [progress, setProgress] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    const categoriesFromDB = await db.categories.toArray();
    setCategories(categoriesFromDB);
  };

  const handleAddCategory = async (e, addAnother = false) => {
    e.preventDefault();

    if (formRef.current.checkValidity()) {
      const newCategory = {
        name: name.trim(),
        parentId: selectedParent ? selectedParent.id : null,
        userId: "someUserId",
        isEdited: 1,
      };
      await db.categories.add(newCategory);
      setName("");
      if (!addAnother) {
        setSelectedParent(null);
        loadCategories();
        setMessage("Successfully Added");
        setMessageType("success");
        startCountdown();
        setTimeout(
          () => {
            navigate(-1);
            setMessage("");
            setMessageType("");
          },

          1000
        );
      } else {
        setMessage("Successfully Added");
        setMessageType("success");
      }
      if (addAnother) {
        setSelectedParent(null);
        loadCategories();
        setMessage("Successfully Added");
        setMessageType("success");
        startCountdown();
        setTimeout(() => {
          setMessage("");
          setMessageType("");
        }, 1000);
      }
    } else {
      formRef.current.reportValidity();
    }
  };

  const startCountdown = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    setIsActive(true);
    setProgress(0);

    let currentProgress = 0;
    const newIntervalId = setInterval(() => {
      currentProgress += 100 / (1 * 10);
      setProgress(currentProgress);
    }, 100);

    setIntervalId(newIntervalId);
  };

  // const startCountdown = () => {
  //   setIsActive(true);
  //   setProgress(0);

  //   let currentProgress = 0;
  //   const intervalId = setInterval(() => {
  //     currentProgress += 100 / (1 * 10);
  //     setProgress(currentProgress);
  //   }, 100);
  //   return () => clearInterval(intervalId);
  // };

  return (
    <div className="container main-div p-2 pt-4 ">
      <div className="display-center pb-4">
        <button
          className="btn verticalAlign position-absolute start-0 "
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="fs-1  material-symbols-outlined">
            chevron_backward
          </span>
        </button>
        <h3 className=" verticalAlign heading-txt">Add Category</h3>
      </div>
      <form
        ref={formRef}
        onSubmit={handleAddCategory}
        className="card child-div  "
      >
        <div className="row pb-3 ">
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label className=" text-color pb-2">Category</label>
            <input
              type="text"
              className="form-control mb-4 "
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
            <label className=" pb-2 text-color">Parent Category</label>
            <CategoryLists
              categories={categories?.filter(
                (category) => category.isDeleted !== 1
              )}
              selectedParent={selectedParent}
              onChange={(e) =>
                setSelectedParent(
                  e.target.value
                    ? categories.find((c) => c.id === parseInt(e.target.value))
                    : null
                )
              }
            />
          </div>
        </div>
        <div className=" display-center pt-5 pb-4 ">
          <button
            className="btn me-3 btn-warning  rounded-pill noSpace"
            onClick={(e) => handleAddCategory(e, true)}
          >
            <span className="material-symbols-outlined verticalAlign me-1">
              more_time
            </span>
            <span className=" verticalAlign">Add Another</span>
          </button>
          <button className="save-btn rounded-pill noSpace" type="submit">
            <span className="material-symbols-outlined verticalAlign me-1">
              save
            </span>
            <span className="verticalAlign ">Save</span>
          </button>
        </div>
        <ErrorSuccessMessage
          message={message}
          messageType={messageType}
          isActive={isActive}
          progress={progress}
        />
      </form>
    </div>
  );
}
export default AddCategory;
